import { DispenserDetailResponse } from '@/features/dispensers/services/schemas.ts';
import { DetailCard } from '@/common/components/detail-card/DetailCard.tsx';
import { Trans } from '@lingui/react/macro';
import { PropertyList } from '@/common/components/property-list/PropertyList.tsx';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export interface CollectorInfoCardProps {
  data: DispenserDetailResponse['collector'];
}

export const CollectorInfoCard = ({ data }: CollectorInfoCardProps) => {
  return (
    <DetailCard title={<Trans>Collector Information</Trans>}>
      <PropertyList>
        <PropertyList.Item label={<Trans>PC Identifier</Trans>} value={data?.computerId} />
        <PropertyList.Item
          label={<Trans>Software</Trans>}
          value={data?.swVersion?.softwareVersion}
        />
        <PropertyList.Item
          direction={{ xs: 'column', sm: 'row' }}
          label={<Trans>Databases</Trans>}
          value={
            !data?.swVersion || data?.swVersion?.dbVersionList.length === 0 ? null : (
              <Stack gap={1}>
                {data.swVersion.dbVersionList.map((db) => (
                  <Stack key={db.path}>
                    <Typography variant="inherit" sx={{ overflowWrap: 'break-word' }}>
                      {db.path}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      {db.version}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
            )
          }
        />
      </PropertyList>
    </DetailCard>
  );
};
